import { Device } from "@capacitor/device";
import apiClient, { extractData } from "./client";

const LAST_PUSH_TOKEN_KEY = "ess_last_push_token";
const APP_DEVICE_ID_KEY = "app_device_id";

export function getStoredPushToken() {
  return localStorage.getItem(LAST_PUSH_TOKEN_KEY);
}

export function setStoredPushToken(token) {
  if (token) {
    localStorage.setItem(LAST_PUSH_TOKEN_KEY, token);
  } else {
    localStorage.removeItem(LAST_PUSH_TOKEN_KEY);
  }
}

async function resolveDeviceId() {
  try {
    const info = await Device.getId();
    if (info?.identifier) {
      return info.identifier;
    }
  } catch {
    // Capacitor Device API unavailable (web dev, etc.)
  }

  const stored = localStorage.getItem(APP_DEVICE_ID_KEY);
  if (stored) {
    return stored;
  }

  const id = crypto.randomUUID();
  localStorage.setItem(APP_DEVICE_ID_KEY, id);
  return id;
}

export async function registerDevice({
  token,
  platform = "android",
  deviceName,
  appVersion,
}) {
  const deviceId = await resolveDeviceId();
  const response = await apiClient.post("/devices", {
    token,
    platform,
    deviceId,
    ...(deviceName ? { deviceName } : {}),
    ...(appVersion ? { appVersion } : {}),
  });
  setStoredPushToken(token);
  return extractData(response);
}

export async function unregisterDevice(token) {
  if (!token) return;
  await apiClient.delete("/devices", { data: { token } });
}

export async function unregisterStoredDevice() {
  const token = getStoredPushToken();
  if (!token) return;
  try {
    await unregisterDevice(token);
  } catch {
    // Keep the local FCM token. Logout may race the JWT, and the next login
    // needs the same device token to re-bind this phone to the new account.
  }
}
